import React, {Fragment} from 'react';
import {Button, Dimmer, Icon, Popup, Segment, Table} from "semantic-ui-react";
import Loader from "../../../components/Loader/Loader";
import TableStyled from "../../../components/Table/Table";
import numeral from "numeral";
import {Trans} from "react-i18next";
import Logos from "./logos";
import Info from "../../../components/Info";
import {customMatchingServices, declOfNum, formServicesArray} from "./utils";
import i18n from "../../../services/i18n";
import {costFormat} from "../../../services/cost";
import {getCarrierUiExtension} from "./carrierExtensions";

const renderDays = (number, currentLanguage) => {
    if (currentLanguage === "ru") {
        return (<span>{number} {declOfNum(number, ['день', 'дня', 'дней'])}</span>);
    } else if (currentLanguage === "en") {
        return (<span>{number} days</span>);
    }
    return null;
}

const renderTariff = (collection, entry, ind, currentLanguage = 'ru', disabled, form, changeParam, setStep, isCalc, isCalcV2, isCostCalc, onClickSendBtn, isView) => {
    const carrierExtension = getCarrierUiExtension(entry);

    const hasHouseNumber = (address) => {
        if (!address) return false;
        return !!(address.house && address.house.trim()) || !!(address.building && address.building.trim());
    };

    const handleSelectTariff = (collection, index, deliveryDays) => {
        // Блокируем переход для Яндекса и Достависты при неполных адресах
        const selectedTariff = collection[index];
        const tariffCarrierCode = selectedTariff.carrierCode || (selectedTariff.displayData && selectedTariff.displayData.carrierCode);
        const isTariffYandexOrDostavista = tariffCarrierCode === 'Ya' || tariffCarrierCode === 'Dostavista';
        if (isTariffYandexOrDostavista && form && (!hasHouseNumber(form.shipmentAddress) || !hasHouseNumber(form.deliveryAddress))) {
            return; // Не выполняем переход
        }
        
        let selectedTariffFinal = collection[index];
        setStep(4);
        changeParam('selectedTariff', selectedTariffFinal);
        changeParam('carrierPublicOfferUrl', selectedTariffFinal.carrierPublicOfferUrl);
        changeParam('deliveryDay', deliveryDays);
        carrierExtension.onTariffSelected({
            selectedTariff: selectedTariffFinal,
            changeParam
        });
    }

    // Проверяем, нужно ли блокировать кнопку для Яндекса и Достависты при неполных адресах
    const carrierCode = entry.carrierCode || (entry.displayData && entry.displayData.carrierCode);
    const isYandexOrDostavista = carrierCode === 'Ya' || carrierCode === 'Dostavista';
    const isAddressIncomplete = form && (!hasHouseNumber(form.shipmentAddress) || !hasHouseNumber(form.deliveryAddress));
    const shouldBlockTariff = isYandexOrDostavista && isAddressIncomplete;
    const isTariffDisabled = disabled;

    const renderEntryStatus = (entryStatus, statusComment) => {
        let text = null;
        let color = null;

        switch (entryStatus) {
            case 'Sent': {
                text = 'Заявка отправлена';
                color = 'yellow';
                break;
            }
            case 'Error': {
                text = 'Ошибка';
                color = 'red';
                break;
            }
            case 'Complete': {
                text = 'Заявка обработана';
                color = 'green';
                break;
            }
            case 'Skip': {
                text = 'Без интеграции';
                color = 'blue';
                break;
            }
            default:
                break;
        }

        return (text && color) ? <div className={`cost-calc-status ${color}`} title={statusComment}>{text}</div> : null;
    }

    let displayData = entry.displayData || {};
    const shortTitle = carrierExtension.getShortTariffTitle(entry);
    let entryCost = displayData.cost ? numeral(displayData.cost).format("0.00") : '';
    let deliveryDays;
    if (displayData.maxDeliveryDay !== undefined && displayData.maxDeliveryDay !== "") {
        deliveryDays =
            <div>
                <Trans>{displayData.minDeliveryDay}</Trans><span> - </span><Trans>{displayData.maxDeliveryDay}</Trans>
            </div>;
    } else {
        deliveryDays = <div><Trans>{displayData.minDeliveryDay}</Trans></div>;
    }

    const calcCost = (entryCost = 0) => {
        //расчет стоимости с учетом выбранных услуг
        let cost = Number.parseFloat(entryCost);
        formServicesArray(form).forEach(fs => {
            const availableServices = entry.services || []
            const service = availableServices.find(s => s.code === fs || customMatchingServices(fs, s.code, entry.carrierCode)) || {};
            cost += service.cost || 0;
        })
        return cost.toFixed(2);
    }

    return (<Table.Row className={entry.isSelected ? 'row_green' : ''} key={'tariff_' + ind}>
        <Table.Cell>
            <Logos
                className={(isCalc && !isCalcV2) ? 'blur' : undefined}
                name={entry.carrierCode}
            />
        </Table.Cell>
        {!isCalc && <Table.Cell colSpan='2' className='table__info'>
            <div className='carrier-tariff-inline carrier-tariff-inline_result'>
                <Info
                    className='carrier-tariff-inline__icon'
                    name={displayData.carrierName || entry.carrierName}
                    label={displayData.carrierServiceName}
                    text={displayData.carrierServiceDescription}
                    position={'left'}
                    offset={[-10]}
                />
                <div className='carrier-tariff-inline__title'>{shortTitle}</div>
            </div>
        </Table.Cell>}
        <Table.Cell>
            <div className='table__date'>{displayData.departureDate}</div>
            <div className='table__week-day'><Trans>{displayData.departureDay}</Trans></div>
        </Table.Cell>
        {
            (!(isCostCalc && isNaN(calcCost(entryCost))) && !displayData.maxDeliveryDay && !displayData.minDeliveryDay && !displayData.deliveryTime) ?
                <Table.Cell colSpan='2' style={{paddingLeft: '5%'}}>
                    Уточните у менеджера
                </Table.Cell> :
                <Fragment>
                    <Table.Cell textAlign='center'>
                        {displayData.maxDays === 0 ?
                            <div className='table__days-count table__days-count_0'>0 дней</div> :
                            <div className='table__days-count'>{displayData.maxDays ? renderDays(displayData.maxDays, currentLanguage) : ''}</div>}
                    </Table.Cell>
                    <Table.Cell>
                        <div className='table__date'>{displayData.deliveryTime}</div>
                        <div className='table__week-day'>{deliveryDays}</div>
                    </Table.Cell>
                </Fragment>
        }

        <Table.Cell style={{minWidth: isCostCalc && '175px'}} textAlign='center'>
            {!isNaN(calcCost(entryCost)) && (isCalc || (isCostCalc && isView)  ? <div className='table__cost-calc'>{costFormat(calcCost(entryCost))} ₽</div>
                : (!isCostCalc ? (
                    shouldBlockTariff ? (
                        <Popup
                            trigger={
                                <div style={{display: 'inline-block'}}>
                                    <Button
                                        disabled={isTariffDisabled}
                                        onClick={() => handleSelectTariff(collection, ind, displayData.maxDeliveryDay)}
                                        className='table__btn'
                                    >
                                        {displayData.isCostHidden ? (
                                            <Info
                                                name=""
                                                label=""
                                                text={displayData.costHiddenMessage || 'Для определения стоимости отправки необходимо указать полные адреса до номера дома для точки отправления и точки доставки'}
                                                position={'top center'}
                                                offset={[0]}
                                            />
                                        ) : `${costFormat(calcCost(entryCost))} ₽`}
                                    </Button>
                                </div>
                            }
                            content='Для определения стоимости отправки необходимо указать полные адреса до номера дома для точки отправления и точки доставки'
                            position='top center'
                            on='hover'
                            mouseEnterDelay={0}
                            mouseLeaveDelay={0}
                        />
                    ) : (
                        <Button
                            disabled={isTariffDisabled}
                            onClick={() => handleSelectTariff(collection, ind, displayData.maxDeliveryDay)}
                            className='table__btn'
                        >
                            {displayData.isCostHidden ? (
                                <Info
                                    name=""
                                    label=""
                                    text={displayData.costHiddenMessage || 'Для определения стоимости отправки необходимо указать полные адреса до номера дома для точки отправления и точки доставки'}
                                    position={'top center'}
                                    offset={[0]}
                                />
                            ) : `${costFormat(calcCost(entryCost))} ₽`}
                        </Button>
                    )
                ) : (
                    shouldBlockTariff ? (
                        <Popup
                            trigger={
                                <div style={{display: 'inline-block'}}>
                                    <Button
                                        disabled={isTariffDisabled}
                                        onClick={() => {
                                            // Блокируем открытие модального окна для Яндекса и Достависты при неполных адресах
                                            if (!shouldBlockTariff) {
                                                onClickSendBtn(entry);
                                            }
                                        }}
                                        className='table__btn step-btn-block__btn_final table__btn cost-calc_btn'
                                        color='blue'
                                        text={`${costFormat(calcCost(entryCost))} ₽`}
                                    >
                                        <span>
                                            Выбрать <br/> вариант доставки
                                        </span>
                                    </Button>
                                </div>
                            }
                            content='Для определения стоимости отправки необходимо указать полные адреса до номера дома для точки отправления и точки доставки'
                            position='top center'
                            on='hover'
                            mouseEnterDelay={0}
                            mouseLeaveDelay={0}
                        />
                    ) : (
                        <Button
                            disabled={isTariffDisabled}
                            onClick={() => onClickSendBtn(entry)}
                            className='table__btn step-btn-block__btn_final table__btn cost-calc_btn'
                            color='blue'
                            text={`${costFormat(calcCost(entryCost))} ₽`}
                        >
                            <span>
                                Выбрать <br/> вариант доставки
                            </span>
                        </Button>
                    )
                )))}
        </Table.Cell>
        {isCalc && <Table.Cell textAlign='center'>
            <Button onClick={() => {
                if (isCalcV2) ym(49255948, 'reachGoal', 'click-order');
                window.open('https://pooling.me/contactwithus', "_self")
            }}
                    className='table__btn table__btn_big'>
                Заказать
            </Button>
        </Table.Cell>}
        {isCostCalc && <Table.Cell>
            {renderEntryStatus(entry.status, entry.statusComment)}
        </Table.Cell>}
    </Table.Row>)
}

const ResultData = ({tariffs, loading, form, changeParam, setStep, isCalc = false, isCalcV2 = false, isCostCalc = false, onClickSendBtn, isView}) => {
    i18n.changeLanguage('ru');

    return <Segment className='b-b-0' vertical>
        <Dimmer inverted active={loading} className={'result-dimmer'}>
            <Loader label={'Загрузка предложений'} description={'Поиск тарифов в системе'}/>
        </Dimmer>
        <TableStyled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Перевозчик</Table.HeaderCell>
                    {!isCalc && <Table.HeaderCell colSpan='2'/>}
                    <Table.HeaderCell>Плановая дата отгрузки</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>В пути</Table.HeaderCell>
                    <Table.HeaderCell>{!isCostCalc ? 'Ожидаемая дата' : 'Дата'} доставки</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>{!isCostCalc ? 'Тариф' : 'Стоимость'} (с НДС)</Table.HeaderCell>
                    {isCalc && <Table.HeaderCell textAlign='center'/>}
                    {isCostCalc && <Table.HeaderCell>Статус</Table.HeaderCell>}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {
                    tariffs && tariffs.map((tariff, index) => renderTariff(tariffs, tariff, index, 'ru', loading, form, changeParam, setStep, isCalc, isCalcV2, isCostCalc, onClickSendBtn, isView))
                }
                {
                    (!tariffs || tariffs.length === 0) && !loading && <Table.Row className='disabled-tr'>
                        <Table.Cell textAlign='center' colSpan={!isCostCalc ? 7 : 8}>
                            Варианты доставки не найдены
                        </Table.Cell>
                    </Table.Row>
                }
            </Table.Body>
        </TableStyled>
    </Segment>
}

export default ResultData;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/resultData.jsx